import { format } from 'date-fns'
import { WellGeothermalPressureFields } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { DISPLAY_DATE_FORMAT, INTERNAL_DATE_FORMAT } from '../../../services/constants'
import { parseDate } from '../../aoraki/generic-search-common/src'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { DateField, FormField, InputWidth, TextInput } from '@msaf/core-react'

interface WellGeothermalPressureInterface {
  fields: Partial<WellGeothermalPressureFields>
  index: number
  isLoading: boolean
  setValue: SetValue<WellGeothermalPressureFields>
  validationErrors: ValidationErrors<WellGeothermalPressureFields>
}

export default function WellGeothermalPressureEdit({
  fields,
  isLoading,
  validationErrors,
  setValue,
}: WellGeothermalPressureInterface) {
  return (
    <>
      <FormField isSkeleton={isLoading} label='Date' htmlFor='date' validationMessages={validationErrors?.date}>
        <DateField
          isSkeleton={isLoading}
          isDisabled={isLoading}
          fieldSize={InputWidth.large}
          dateFormat={DISPLAY_DATE_FORMAT}
          selectedDate={parseDate(fields.date)}
          setSelectedDate={(date: Date) => setValue('date', date ? format(date, INTERNAL_DATE_FORMAT) : '')}
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Depth (m)' htmlFor='depth' validationMessages={validationErrors?.depth}>
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          fieldSize={InputWidth.large}
          id='depth'
          value={`${fields.depth ?? ''}`}
          setValue={(value) => setValue('depth', value)}
          isInvalid={!!validationErrors?.depth}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Pressure (kPa)'
        htmlFor='pressure'
        validationMessages={validationErrors?.pressure}
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          fieldSize={InputWidth.large}
          id='pressure'
          value={`${fields.pressure ?? ''}`}
          setValue={(value) => setValue('pressure', value)}
          isInvalid={!!validationErrors?.pressure}
        />
      </FormField>
    </>
  )
}
